export enum GlobalOptions {
    MAX_VISIBLE_MATERIAL_DROPDOWN_ITEMS = 4,
    FILTERS_VERSION = '15',
    ALL = 'all',
    DEFAULT_PRICELIST_VERSION = '-25',
    HEIGHT_PID = 'p7403',
    FINAL_HEIGHT_PID = 'p740650',
    WIDTH_PID = 'p7402',
    FINAL_WIDTH_PID = 'p740649',
    QUANTITY_PID = 'p7404',
    POSITION_PID = 'p7408',
    PRICELIST_PID = 'p7407',
    SISTEM_PID = 'p7405',
    SYSTEM_COLOR_PID = 'p74018',
    MANUAL_REGISTRATION_VID = 'ROČNI VPIS',
    FRAME_WIDTH_PID = 'p740664',
    FRAME_HEIGHT_PID = 'p740665',
    WIDTH_SASH_PID = 'p740666',
    DRIVE_PID = 'p5543',
    LEFT_GUIDE_PID = 'p10468',
    RIGHT_GUIDE_PID = 'p10469',
    ALTERNATIVE_LEFT_GUIDE_PID = 'p40117',
    ALTERNATIVE_RIGHT_GUIDE_PID = 'p40118',
    TOTAL_WIDTH_PID = 'p10302',
    ASSEMBLY_POSITION_PID = 'p40146',
    COMBINATION_TYPE_PID = 'p32678',
    NUMBER_OF_COMBINATIONS_PID = 'p40145',
}

export const MANDATORY_SIMPLE_PRODUCT_CATEGORIES = ['INSECT_SCREENS'];
export const COMMON_FIELD_PIDS = [
    GlobalOptions.QUANTITY_PID,
    GlobalOptions.WIDTH_PID,
    GlobalOptions.HEIGHT_PID,
    GlobalOptions.POSITION_PID,
    GlobalOptions.SISTEM_PID,
] as string[];

export const PASTED_FIELD_PIDS = [
    GlobalOptions.QUANTITY_PID,
    GlobalOptions.WIDTH_PID,
    GlobalOptions.HEIGHT_PID,
    GlobalOptions.POSITION_PID,
] as string[];

export const ALTERNATIVE_PASTED_FIELD_PIDS = [
    GlobalOptions.QUANTITY_PID,
    GlobalOptions.POSITION_PID,
    GlobalOptions.FRAME_WIDTH_PID,
    GlobalOptions.FRAME_HEIGHT_PID,
] as string[];

export const CombinationsOptions = {
    SISTEM_PID: GlobalOptions.SISTEM_PID,
    QUANTITY_PID: GlobalOptions.QUANTITY_PID,
    WIDTH_PID: GlobalOptions.WIDTH_PID,
    HEIGHT_PID: GlobalOptions.HEIGHT_PID,
    POSITION_PID: GlobalOptions.POSITION_PID,
    DRIVE_PID: GlobalOptions.DRIVE_PID,
    LEFT_GUIDE_PID: GlobalOptions.LEFT_GUIDE_PID,
    RIGHT_GUIDE_PID: GlobalOptions.RIGHT_GUIDE_PID,
    TOTAL_WIDTH_PID: GlobalOptions.TOTAL_WIDTH_PID,
    ASSEMBLY_POSITION_PID: GlobalOptions.ASSEMBLY_POSITION_PID,
    COMBINATION_TYPE_PID: GlobalOptions.COMBINATION_TYPE_PID,
    NUMBER_OF_COMBINATIONS_PID: GlobalOptions.NUMBER_OF_COMBINATIONS_PID, // Using quantity PID for number of combinations as well
};
